import { useState, useEffect, useContext, useRef } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { usePDF, Resolution, Margin } from "react-to-pdf";

import PrintView from "./components/PrintView";
import "./css/task.css";

import { AppContext } from "../../Context";
import { Loader, GET } from "../../inc/Fetch";

export default function Print({ action }) {
    let location = useLocation();
    let params = useParams();
    const { toPDF, targetRef } = usePDF({
        filename: "yallangany.pdf",
        resolution: Resolution.HIGH,
        method: "open",
        page: {
            // margin is in MM, default is Margin.NONE = 0
            margin: Margin.SMALL,
        },
    });

    const [loader, setloader] = useState(true);

    const { successData, userData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;

    async function loadData() {
        let r = await GET(`task/loadTask/?_id=${params?.id}`);
        return r;
    }

    const { data, error, isLoading } = useQuery(`task-${params?.id}`, loadData);

    useEffect(() => {
        if (params?.type == "pdf" && !isLoading) {
            setTimeout(() => {
                // toPDF();
            }, 500);

            setTimeout(() => {
                setloader(false);
            }, 4000);
        }

        if (params?.type == "print" && !isLoading) {
            setTimeout(() => {
                window.print();
            }, 500);
        }
    }, [isLoading]);

    return (
        <>
            <PrintView data={data} targetRef={targetRef} />
        </>
    );
}
